import Vue from 'vue';
import VueHead from 'vue-head';
import Vuelidate from 'vuelidate';
import VueClipboard from 'vue-clipboard2';
import VueCurrencyFilter from 'vue-currency-filter';
import MoveTo from 'moveto';
import { VueHammer } from 'vue2-hammer';

import logrocket from '@/services/logrocket';
import { initI18n } from '@/services/i18n-setup';

import Capusta from './Capusta.vue';
import router from './router';
import store from './store';

import 'styles/variables.css';
import './styles/main.sass';

import filters from '@/services/filters';
import directives from '@/services/directives';

import layoutDirectives from 'plugins/layoutDirectives';
import formatInputAmount from 'plugins/formatInputAmount';
layoutDirectives();
formatInputAmount();

// eslint-disable-next-line no-unused-vars
import customPrototypes from '@/services/customPrototypes';

import CapustaAlert from '@/plugins/capusta_alert/index';
import CapustaInfo from '@/plugins/capusta_info/index';
import CapustaPrice from '@/plugins/capusta_price/index';
import CapustaPopup from '@/plugins/capusta_popup/index';
import dateFns from '@/plugins/dateFns/index';
import ResponsiveController from 'plugins/responsive';

import InfoBlock from '@/components/main/InfoBlock';

import registerPlugins from 'lib/plugins';
import components from '../../components/components';

import { ScrollbarDirective } from '../../components/Scrollbar';
Vue.directive('scrollbar', ScrollbarDirective);

const isDev = process.env.NODE_ENV === 'development';

registerPlugins(Vue);

Object.keys(components).forEach(key => {
  Vue.component(key, components[key]);
});

VueHammer.config.pinch = {
  enable: true,
  touchAction: 'auto',
};

Vue.prototype.$moveTo = function (options) {
  return new MoveTo(options);
};

Vue.prototype.$openLink = function (link, blank, checkHttp) {
  if (checkHttp) { link = link.match(/^http[s]?:\/\//) ? link : `//${link}`; }
  window.open(link, blank ? '_blank' : '_self');
};

Vue.use(VueCurrencyFilter, {
  thousandsSeparator: ' ',
  fractionSeparator: ',',
  fractionCount: 2,
  symbolPosition: 'back',
  symbolSpacing: true,
});

Vue.use(VueHead);
Vue.use(Vuelidate);
Vue.use(VueClipboard);
Vue.use(VueHammer);
Vue.use(dateFns);

Vue.use(CapustaPrice);
Vue.use(CapustaPopup);
Vue.use(CapustaAlert);
Vue.use(CapustaInfo);
Vue.use(ResponsiveController);

Vue.component('InfoBlock', InfoBlock);

for (let filter of filters) {
  Vue.filter(filter.name, filter.func);
}

for (let directive of directives) {
  Vue.directive(directive.name, directive.directive);
}

Vue.config.productionTip = false;

Vue.prototype.$eventBus = new Vue();

if (!isDev) {
  logrocket.init();
}

initI18n().then(i18n => {
  new Vue({
    i18n,
    router,
    store,
    render: h => h(Capusta),
  }).$mount('#app');
});
